<template>
  <v-container id="vehicles" fluid tag="section">
    <div class="text-right">
      <v-btn
        color="cyan"
        v-if="showGrid"
        @click="showFilter = !showFilter"
        small
      >
        <v-icon>mdi-filter</v-icon>
      </v-btn>
      <v-btn
        color="secondary"
        class="mr-0"
        small
        v-if="singlePage && !showGrid"
        @click="
          showGrid = !showGrid;
          vehicle_id = null;
        "
      >
        <v-icon v-if="showGrid">mdi-plus</v-icon>
        <v-icon v-if="!showGrid">mdi-grid</v-icon>
        {{ $i18n.t("All") }}
      </v-btn>
      <v-menu offset-y v-if="showGrid">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="secondary" small>
            <h3>
              {{ $i18n.t("Action") }}
              <v-icon>mdi-menu-down</v-icon>
            </h3>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :to="'/vehicle/create'" v-if="!singlePage">
            <v-icon>mdi-plus</v-icon>
            <v-list-item-title class="ms-3">{{
              $i18n.t("Add New")
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="uploadT()">
          <v-icon>mdi-upload</v-icon>
            <v-list-item-title class="ms-3">{{ $i18n.t("Bulk Upload") }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="singlePage"
            @click="
              showGrid = !showGrid;
              vehicle_id = null;
            "
          >
            <v-icon>mdi-plus</v-icon>
            <v-list-item-title class="ms-3">{{
              $i18n.t("Add New")
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="showBulkModificationModal">
            <v-icon>mdi-refresh</v-icon>
            <v-list-item-title class="ms-3">
              {{ $i18n.t("Bulk Modification") }}
            </v-list-item-title>
          </v-list-item>
          <!-- <v-list-item @click="showBulkUpload = true">
            <v-icon>mdi-cloud-upload</v-icon>
            <v-list-item-title class="ms-3">
              {{ $i18n.t("Bulk Upload") }}
            </v-list-item-title>
          </v-list-item> -->
          <v-list-item>
            <z-confirm-button
              class="float-right list-item-btn"
              small
              text
              :loading="loading"
              :message="$i18n.t('Do you want to delete selected Vehicles ?')"
              @click="deleteSelected"
            >
              <v-icon>mdi-trash-can-outline</v-icon>
              <span class="ms-3">{{ $i18n.t("Delete Selected") }}</span>
            </z-confirm-button>
            <!-- <v-list-item-title></v-list-item-title> -->
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <vehicle-edit
      v-if="!showGrid"
      :vehicle_id="vehicle_id"
      :singlePage="singlePage"
      @select="select"
    />

    <v-dialog
      v-model="showBulkUpload"
      transition="dialog-top-transition"
      width="600"
    >
      <v-card>
        <v-toolbar dark color="cyan" fixed class="sticky-top">
          <v-toolbar-title>
            <v-icon>mdi-filter</v-icon>
            {{ $i18n.t("Bulk Upload") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="showBulkUpload = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-file-input
            chips
            :label="$i18n.t('Vehicle XLS File') + '*'"
            @change="handleXLSupload()"
            v-model="vehicleUploadFile"
          ></v-file-input>
          {{ $i18n.t("Upload vehicles detail in xlsx file.") }}
          {{ $i18n.t("A Sample xlsx can be found") }}
          <a
            href="/xls/vehiclesample.xlsx?v=JSVERSION"
            target="_blank"
            class="color-green"
            >{{ $i18n.t("here") }}</a
          >
        </v-card-text>
        <v-card-actions class="sticky-bottom">
          <v-spacer></v-spacer>

          <v-btn
            color="success"
            class="mr-0"
            small
            dark
            @click="bulkUploadVehicle"
            :loading="loading"
          >
            <v-icon>mdi-cloud-upload</v-icon>
            &nbsp;
            {{ $i18n.t("Upload") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row justify="center" v-if="showGrid && showFilter">
      <v-col cols="12" md="12">
        <base-material-card
          color="cyan"
          icon="mdi-filter"
          class="px-3 py-1 small-icon"
          v-if="showFilter"
        >
          <div class="filter-close">
            <v-btn
              color="black"
              class="mr-0"
              fab
              small
              text
              @click="showFilter = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="12" sm="12" md="4" lg="3">
              <v-btn-toggle
                rounded
                style="float: left; background: transparent; margin-top: 20px"
              >
                <v-btn
                  small
                  :color="tab === 'active' ? 'secondary' : 'grey'"
                  @click="
                    tab = 'active';
                    search();
                  "
                >
                  <h3 style="padding-right: 20px">
                    <!-- <div style="width:20px;height:12px;float:left" v-if="tab !== 4"></div> -->
                    {{ $i18n.t("Active") }}
                  </h3>
                </v-btn>

                <v-btn
                  small
                  :color="tab === 'inactive' ? 'secondary' : 'grey'"
                  @click="
                    tab = 'inactive';
                    search();
                  "
                >
                  <h3 style="padding-right: 20px">
                    <!-- <div style="width:20px;height:12px;float:left" v-if="tab !== 1"></div> -->
                    {{ $i18n.t("Inactive") }}
                  </h3>
                </v-btn>

                <v-btn
                  small
                  :color="tab === 'sold' ? 'secondary' : 'grey'"
                  @click="
                    tab = 'sold';
                    search();
                  "
                >
                  <h3 style="padding-right: 20px">
                    <!-- <div style="width:20px;height:12px;float:left" v-if="tab !== 1"></div> -->
                    {{ $i18n.t("Sold") }}
                  </h3>
                </v-btn>
              </v-btn-toggle>
            </v-col>

            <v-col cols="12" sm="12" md="3" lg="2">
              <v-text-field
                :label="$i18n.t('Registration No.')"
                class="purple-input"
                v-model="filter.regNo"
                clearable
              />
            </v-col>

            <v-col cols="12" sm="12" md="3" lg="2">
              <z-name-master-select
                :hideAddNew="true"
                class="purple-input"
                v-model="filter.bodyType"
                :label="'Body Type'"
                :type="10"
              />
            </v-col>

            <v-col cols="12" sm="12" md="3" lg="2">
              <z-vehicle-type-select
                class="purple-input"
                v-model="filter.truckType"
                categories="true"
              />
            </v-col>

            <v-col cols="12" sm="12" md="3" lg="2">
              <z-vehicle-type-select
                label="Vehicle Type"
                clearable
                class="purple-input"
                v-model="filter.vehicleType"
              />
            </v-col>

            <v-col cols="12" sm="12" md="3" lg="2">
              <z-vendor-select
                withSelf
                clearable
                class="purple-input"
                v-model="filter.vendor"
                label="Owner"
              />
            </v-col>

            <v-col cols="12" sm="12" md="3" lg="2">
              <v-text-field
                :label="$i18n.t('Body Length')"
                v-model="filter.length"
                type="number"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                maxlength="7"
              >
                <span slot="append" color="purple"> Feet </span>
              </v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="3" lg="2">
              <v-text-field
                :label="$i18n.t('Capacity')"
                v-model="filter.capacity"
                type="number"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                maxlength="7"
              >
                <span slot="append" color="purple"> Tonnes </span>
              </v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="3" lg="2">
              <v-select
                :label="$i18n.t('Axel')"
                :items="[
                  { name: 'Single Axel', value: 1 },
                  { name: 'Multi Axel', value: 2 },
                ]"
                v-model="filter.axel"
                item-text="name"
                item-value="value"
                type="number"
              ></v-select>
            </v-col>

            <v-col cols="12" sm="12" md="3" lg="2">
              <v-text-field
                :label="$i18n.t('Wheels')"
                v-model="filter.wheels"
                type="number"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                maxlength="3"
              >
                <v-icon slot="append" color="purple"> mdi-wheel </v-icon>
              </v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="3" lg="2">
              <z-zone-select
                clearable
                class="purple-input"
                v-model="filter.zone"
              />
            </v-col>

            <!-- <v-col cols="12" sm="12" md="3" lg="2">
              <z-country-select
                clearable
                :label="$i18n.t('Country')"
                class="purple-input"
                v-model="filter.country"
              ></z-country-select>
            </v-col> -->

            <v-col cols="12" sm="12" md="3" lg="2">
              <v-select
                :label="$i18n.t('Status')"
                class="purple-input"
                v-model="filter.status"
                :items="statusList"
                item-text="name"
                item-value="value"
                clearable
              ></v-select>
            </v-col>
            <v-row>
              <v-spacer />
              <v-col cols="12" sm="12" md="3" lg="2">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="mr-0"
                      color="grey darken"
                      fab
                      text
                      small
                      @click="clear(1)"
                      style="margin-right: 10px !important"
                      v-on="on"
                    >
                      <v-icon>mdi-cached</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $i18n.t("Clear Filter") }}</span>
                </v-tooltip>
                <v-btn
                  color="success"
                  class="mr-0"
                  fab
                  small
                  dark
                  @click="search()"
                  :loading="loading"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>

    <bulk-modification-vehicle
      :showDialog="showBulkUpdateDialog"
      :payload="payload"
      :refresh="refresh"
      @closeDialog="closeDialog"
    />

    <v-btn
      v-if="showGrid && grid != undefined && !grid.records"
      class="text-center secondary--text pa-10"
      text
      color="primary"
      style="width: 100%"
      :loading="loading"
      >{{ $i18n.t("No records available") }}</v-btn
    >

    <base-material-card
      icon="mdi-car"
      :title="$i18n.t('Vehicles')"
      class="px-5 py-3 small-icon"
      v-if="showGrid && grid.records"
      color="primary"
    >
      <z-grid-record :grid="grid" />

      <!-- <v-card class="py-0 my-2" elevation="1" color="blue lighten-5 d-none d-md-flex">
        <v-card-text class="py-0">
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="10" lg="10">
              <v-row>
                <v-col cols="12" md="5" lg="5">
                  <v-row>
                    <v-col cols="12" md="1"></v-col>
                    <v-col cols="12" md="3"></v-col>
                    <v-col cols="12" md="8">{{ $i18n.t("Vehicle Details")}}</v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="3" lg="4">{{ $i18n.t("Driver Detail") }}</v-col>
                <v-col cols="12" md="2" lg="2">{{ $i18n.t("Vendor") }}</v-col>
                <v-col cols="12" md="2" lg="1">{{ $i18n.t("Country") }}</v-col>
              </v-row>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="2" lg="2" class="text-right pl-0">
              {{
              $i18n.t("Action")
              }}
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>-->

      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                <v-checkbox
                  v-model="selectAll"
                  class="my-0"
                  style="height: 27px"
                />
              </th>
              <th class="text-left">{{ $i18n.t("Reg No") }}</th>
              <th class="text-left">{{ $i18n.t("Body Type") }}</th>
              <th class="text-left">{{ $i18n.t("Truck Type") }}</th>
              <th class="text-left">{{ $i18n.t("Axel") }}</th>
              <th class="text-left">{{ $i18n.t("Capacity") }}</th>
              <th class="text-left">{{ $i18n.t("KMs") }}</th>
              <th class="text-left">{{ $i18n.t("Mfg") }}</th>
              <th class="text-left">{{ $i18n.t("Owner") }}</th>
              <th class="text-left">{{ $i18n.t("Driver") }}</th>
              <th class="text-right"></th>
            </tr>
          </thead>
          <vehicle-row
            v-for="item in grid.rows"
            :key="item._id"
            :value="item"
            @reload="reload"
            :selected="selectAll"
            :refresh="refresh"
            @select="select"
            :showSelectBtn="showSelectBtn"
            @editVehicle="editVehicle"
            :singlePage="singlePage"
          />
        </template>
      </v-simple-table>

      <!-- <v-virtual-scroll
        :bench="5"
        :items="grid.rows"
        :height="gridHeight"
        :item-height="itemHeight"
      >
        <template v-slot="{ item }">
          <vehicle-row :value="item" @reload="reload" :selected="selectAll" :refresh="refresh" />
          <v-divider></v-divider>
        </template>
      </v-virtual-scroll>-->

      <v-container>
        <v-pagination
          v-model="grid.page"
          class="my-4"
          :length="grid.total"
          total-visible="10"
          @input="showPage"
        ></v-pagination>
      </v-container>
    </base-material-card>
    <z-download-file
      :requestURL="dowloadVehicleUrl"
      :showDialog="showDownloadByTemplateDialog"
      @closeDialog="closeDialog"
      :kind="4"
      :forUpload="forUpload"
    />
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost, doPostForm } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import VehicleRow from "@/views/vehicle/VehicleRow.vue";
import BulkModificationVehicle from "@/views/vehicle/BulkModificationVehicle.vue";
import VehicleEdit from "@/views/vehicle/VehicleEdit.vue";

@Component({
  name: "Vehicles",
  components: { VehicleRow, BulkModificationVehicle, VehicleEdit },
  props: {
    singlePage: {
      default: false,
    },
    bodyType: {
      default: null,
    },
    truckType: {
      default: null,
    },
    showGrid1: {
      default: true,
    },
    showSelectBtn: {
      default: false,
    },
  },
})
export default class Vehicles extends Vue {
  select_all = false;
  showBulkUpdateDialog = false;
  showBulkUpload = false;
  dowloadVehicleUrl = "";
  forUpload = false;
  showDownloadByTemplateDialog = false;
  selectAll = false;
  grid = { page: 0, rows: [] };
  url = "/api/vehicle/grid?&";
  showFilter = false;
  filterUrl = "";
  on = null;
  page = 1;
  rows = 50;
  selectedVehicles = [];
  payload = {};
  tab = "active";
  showGrid = true;
  vehicle_id = null;

  editVehicle(_id) {
    //This is used for single page application
    this.vehicle_id = _id;
    this.showGrid = false;
  }

  filter = {
    regNo: null,
    vehicleType: null,
    bodyType: null,
    truckType: null,
    capacity: null,
    axel: null,
    wheels: null,
    length: null,
    country: "",
    zone: "",
    vendor: "",
    status: "",
  };

  statusList = [
    {
      name: "Assigned",
      value: "assigned",
    },
    {
      name: "Inservice",
      value: "inservice",
    },
    {
      name: "Unassigned",
      value: "unassigned",
    },
  ];

  select(data) {
    this.$emit("select", data);
    this.showGrid = true;
    // this.clear();
  }

  get loading() {
    return common.loading;
  }

  get gridHeight() {
    return this.windowHeight > 500 ? this.windowHeight - 150 : 300;
  }

  get itemHeight() {
    return this.windowWidth > 960 ? 75 : 240;
  }

  vehicleUploadFile = null;
  handleXLSupload(files) {
    if (files) {
      this.vehicleUploadFile = files[0];
    }
  }

  async bulkUploadVehicle() {
    try {
      common.setLoading(true);
      const formData = new FormData();

      if (this.isSet(this.vehicleUploadFile)) {
        formData.append("file", this.vehicleUploadFile);
      }
      const url = "/api/vehicle/uploadVehicle";
      await doPostForm(url, formData);
      common.setLoading(false);
      common.showMessage("Uploaded Successfully");
      this.showPage(this.page);
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }

  async mounted() {
    this.showGrid = this.showGrid1;
    this.search();
  }

  async showPage(page) {
    common.setLoading(true);
    this.page = page;
    try {
      const grid = await doGet(
        this.url + "rows=" + this.rows + "&page=" + page + this.filterUrl
      );
      if (grid.rows && grid.rows.length > 0) {
        for (let i = 0; i < grid.rows.length; i++) {
          grid.rows[i].selected = false;
          grid.rows[i]._showAssign = false;
        }
      }
      this.grid = grid;
      this.selectAll = false;
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async clear() {
    this.filter = {
      regNo: null,
      vendor: null,
      capacity: null,
      axel: null,
      wheels: null,
      length: null,
      vehicleType: "",
      country: null,
      zone: "",
      status: "",
    };

    this.page = 1;
    this.search();
  }

  async refresh(__i) {
    if (__i == 1) {
      this.search();
    }
  }

  async search() {
    this.filterUrl = "";
    // if (this.truckType) this.filter.truckType = this.truckType;
    // if (this.bodyType) this.filter.bodyType = this.bodyType;
    if (this.filter.regNo) this.filterUrl += "&regNo=" + this.filter.regNo;
    if (this.filter.vendor)
      this.filterUrl += "&vendor_id=" + this.filter.vendor;
    if (this.filter.vehicleType)
      this.filterUrl += "&vehicleType=" + this.filter.vehicleType;
    if (this.filter.bodyType)
      this.filterUrl += "&bodyType=" + this.filter.bodyType;
    if (this.filter.truckType)
      this.filterUrl += "&truckType=" + this.filter.truckType;
    if (this.filter.country)
      this.filterUrl += "&country=" + this.filter.country;
    if (this.tab) this.filterUrl += "&status1=" + this.tab;
    if (this.filter.status2)
      this.filterUrl += "&status2=" + this.filter.status2;
    if (this.filter.zone) this.filterUrl += "&zone_id=" + this.filter.zone;
    if (this.filter.capacity) this.filterUrl += "&capacity=" + this.filter.capacity;
    if (this.filter.axel) this.filterUrl += "&axel=" + this.filter.axel;
    if (this.filter.wheels) this.filterUrl += "&wheels=" + this.filter.wheels;
    if (this.filter.length) this.filterUrl += "&length=" + this.filter.length;
    common.setLoading(true);
    await this.showPage(1);
  }

  async deleteVehicle(vehicle_id) {
    common.setLoading(true);
    try {
      await doGet("/api/vehicle/delete/" + vehicle_id);
      common.showMessage("Deleted Successfully");
      await this.search();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }

  async deleteSelected() {
    common.setLoading(true);
    let ids = "";
    this.grid.rows.forEach(function (t) {
      if (t.selected) ids += t._id + ",";
    });
    if (!this.isSet(ids)) {
      common.setError("Select vehicles to delete");
      common.setLoading(false);
      return;
    }
    try {
      await doPost("/api/vehicle/bulk/delete", { vehicle_ids: ids });
      common.showMessage("Deleted Successfully");
      await this.search();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async reload() {
    this.showPage(this.page);
  }

  closeDialog() {
    this.showBulkUpdateDialog = false;
    this.payload = {};
    this.showDownloadByTemplateDialog = false;
  }

  showBulkModificationModal() {
    const payload = {};

    let count = 0;
    let ids = "";
    this.grid.rows.forEach(function (t) {
      if (t.selected) {
        count++;
        ids += t._id + ",";
      }
    });
    if (count == 0) {
      common.setError("Please select vehicle(s).");
      return;
    }

    this.grid.rows.forEach(function (t) {
      if (t.selected) ids += t._id + ",";
    });

    payload.vehicle_ids = ids;

    this.payload = payload;
    this.showBulkUpdateDialog = true;
  }

   async uploadT() {
    this.dowloadVehicleUrl =
      "/api/vehicle/uploadTemplate?";
    this.forUpload = true;
    this.showDownloadByTemplateDialog = true;
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}
.sticky-bottom {
  position: sticky;
  bottom: 0;
  background-color: white;
  border-top: 1px solid #dfdfdf;
}
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 2;
}

tbody:nth-child(even) {
  background: #fafafa;
}
.thead tr th {
  padding: 0 2px !important;
}
</style>
